import React, { useState } from "react";
import "../assets/css/Hero.css";
import ContactOptions from "./ContactOptions";
import videoBG from "../assets/mp4/hero.mp4"

const Hero = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <section className="bg-hero">
         <video autoPlay loop muted playsInline  className="bg-video">
            <source src={videoBG} type="video/mp4"/>
            Seu navegador não suporta vídeos HTML5.
        </video>
        <div className="video-overlay"></div>

      <div className="row">
      <div className="col-md-8 text-gaotech text-start text-lg-start">
        <p className="title-hero ">Somos especialistas</p>
        <p className="subtitle-hero mb-2">em tecnologia</p>
        <p className="description-gao my-4 mt-sm-3">Nossa missão é tornar sua vida mais simples e conectada<br className="d-none d-sm-block" /> por meio de soluções inovadoras.</p>
        {/*<p className="description-gao mb-lg-3">e conectada por meio de soluções inovadoras.</p>*/}
        <div className="group-btn">
          <button className="hero-contact" onClick={handleShow}>
            Solicitar contato
          </button>
          <button className="hero-services">
            <a href="#services">Serviços</a>
          </button>
        </div>
        </div>

      </div>
      <ContactOptions show={showModal} handleClose={handleClose} />
    </section>
  );
 };

export default Hero;